import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import Dashboard1 from "../assets/images/dashboard-1.png";
import Dashboard2 from "../assets/images/dashboard-5.png";
import Dashboard3 from "../assets/images/dashboard-3.png";
import Dashboard4 from "../assets/images/dashboard-4.png";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getDashboard } from "../redux/actions/dashboardAction";
import { getStore, getStoreUpload } from "../redux/actions/storeAction";
const initialState = {
  startDate: "",
  endDate: "",
  timeFrame: null,
  errors: {},
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const [iState, updateState] = useState(initialState);
  const { startDate, endDate, timeFrame, errors } = iState;

  const { dashboardData } = useSelector((state) => state.dashboard);
  const { totalOrders, totalProducts, totalRevenueGenerated } =
    dashboardData?.data || {};
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateState({
      ...iState,
      [name]: value,
    });
  };

  const [autoAccept, setAutoAccept] = useState(false);
  const [autoId, setAutoId] = useState(null);

  useEffect(() => {
    dispatch(getDashboard({ startDate, endDate, timeFrame: "Today" }));
    dispatch(getStore({})).then((res) => {
      if (res.status === 200) {
        setAutoAccept(res.data.isAutoAccept);
        setAutoId(res.data._id);
      }
    });
  }, []);

  let maxDate = new Date().toISOString().split("T")[0];

  const handleReset = (e) => {
    updateState(initialState);
    dispatch(getDashboard({ timeFrame: "Today" }));
  };

  const handleSubmit = () => {
    dispatch(getDashboard({ startDate, endDate, timeFrame })).then((res) => {
      if (res.status === 200) {
        toast.success(res.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };
  const handleToggle = async () => {
    const newValue = !autoAccept;

    // Instant UI change
    setAutoAccept(newValue);

    try {
      const payload = { isAutoAccept: newValue, _id: autoId };
      const res = await dispatch(getStoreUpload(payload));

      if (res.status === 200) {
        toast.success(res.message);

        // refresh store once
        const storeRes = await dispatch(getStore({}));
        if (storeRes?.status === 200 && storeRes?.data) {
          const { isAutoAccept, _id } = storeRes.data;
          setAutoAccept(isAutoAccept);
          setAutoId(_id);
        }
      } else {
        toast.error(res.message);
        setAutoAccept(!newValue); // rollback
      }
    } catch (err) {
      toast.error("Something went wrong");
      setAutoAccept(!newValue); // rollback
    }
  };

  return (
    <div>
      <Header />
      <SideNav />

      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4>Dashboard</h4>
            </div>
            <div>
              <h3>Auto Accept</h3>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={autoAccept}
                  onChange={handleToggle}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>

          <div class="FilterMain">
            <div class="form-group">
              <label>From</label>
              <input
                type="date"
                class="form-control"
                name="startDate"
                disabled={timeFrame ?? startDate}
                max={maxDate}
                value={startDate}
                onChange={handleChange}
              />
            </div>

            <div class="form-group">
              <label>To</label>
              <input
                type="date"
                class="form-control"
                name="endDate"
                value={endDate}
                disabled={startDate == ""}
                min={startDate && !startDate == ""}
                onChange={handleChange}
                max={maxDate}
              />
            </div>

            <div class="form-group">
              <label> From</label>
              <select
                class="form-control"
                name="timeFrame"
                value={timeFrame}
                onChange={handleChange}
              >
                <option value="">All</option>
                <option value="Today">Today</option>
                <option value="Week">This week</option>
                <option value="Month">This Month</option>
              </select>
            </div>

            <div class="form-group ">
              <label>&nbsp;</label>
              <button class="Button AddButton d-inline" onClick={handleSubmit}>
                Apply
              </button>
              <button class="Button AddButton d-inline" onClick={handleReset}>
                {" "}
                <i className="fa fa-refresh"></i>{" "}
              </button>
            </div>
          </div>
          <div class="OrderArea">
            <h4>Statics Overview</h4>
            <ul>
              <li>
                <Link to="/order-management">
                  <div class="OrderBox">
                    <span>
                      <img src={Dashboard1} />
                    </span>
                    <h3>{totalOrders || 0}</h3>
                    <p>My Orders</p>
                  </div>
                </Link>
              </li>

              <li>
                <Link to="/product-management">
                  <div class="OrderBox">
                    <span>
                      <img src={Dashboard2} />
                    </span>
                    <h3>{totalProducts || 0}</h3>
                    <p>Total Products</p>
                  </div>
                </Link>
              </li>

              <li>
                <Link to="/Report-management">
                  <div class="OrderBox">
                    <span>
                      <img src={Dashboard3} />
                    </span>
                    <h3 style={{ fontSize: "24px" }}>
                      {totalRevenueGenerated || 0}
                    </h3>
                    <p>Total Revenue Generated</p>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
